"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const componentRegistry_1 = __importDefault(require("./componentRegistry"));
const mountedRoots_1 = __importDefault(require("./mountedRoots"));
const renderer_1 = __importDefault(require("./renderer")); // Import the Renderer class
const context_1 = __importDefault(require("./context")); // Import the Renderer class
class DomNest {
    constructor(options) {
        // Options for custom attribute names
        this.options = {
            componentAttr: (options === null || options === void 0 ? void 0 : options.componentAttr) || 'data-component', // default is 'data-component'
            propsAttr: (options === null || options === void 0 ? void 0 : options.propsAttr) || 'data-props', // default is 'data-props'
            loading: (options === null || options === void 0 ? void 0 : options.loading) || 'Loading...', // default loading HTML
            debugProps: (options === null || options === void 0 ? void 0 : options.debugProps) || false // default debugProps
        };
        // Component registry to store registered components
        this.registry = new componentRegistry_1.default();
        this.mountedRoots = new mountedRoots_1.default(); // Use the new MountedRoots class
        this.renderer = new renderer_1.default(this.mountedRoots, this.options); // Instantiate Renderer
        this.context = new context_1.default(this.registry); // Instantiate Context
        //shoertcut for register method
        this.register = this.registry.register.bind(this.registry);
    }
    // Method to parse props from data attributes
    parseProps(element) {
        const props = {}; // Define props with an index signature
        // Parse JSON-style props from the specified attribute
        if (element.getAttribute(this.options.propsAttr)) {
            try {
                Object.assign(props, JSON.parse(element.getAttribute(this.options.propsAttr) || ''));
            }
            catch (error) {
                console.error(`Failed to parse '${this.options.propsAttr}' JSON:`, error);
            }
        }
        // Parse individual data-prop-* attributes
        Object.keys(element.dataset).forEach((key) => {
            if (key.startsWith("prop") && key !== this.options.propsAttr.replace("data-", "")) {
                const propName = key.replace("prop", "").toLowerCase();
                props[propName] = element.dataset[key];
            }
        });
        if (this.options.debugProps) {
            console.log(`DomNest props for:`, element, props);
        }
        return props;
    }
    // Initialize and mount a single component
    initNest(element) {
        const componentName = element.getAttribute(this.options.componentAttr);
        if (!componentName) {
            console.warn(`No component name specified for element:`, element);
            return;
        }
        const registered = this.registry.getComponent(componentName);
        if (registered) {
            const props = this.parseProps(element);
            if (registered.async) {
                this.renderer.renderAsync(element, registered, props); // Use Renderer
            }
            else {
                this.renderer.render(element, registered, props); // Use Renderer
            }
        }
        else {
            const suggestions = this.registry.suggest(componentName);
            console.warn(`Component ${componentName} is not registered. ${suggestions.length ? `Did you mean ${suggestions}?` : ''}`);
        }
    }
    // Initialize and mount components in a specific scope
    init(scope = document) {
        const selector = `[${this.options.componentAttr}]`;
        scope.querySelectorAll(selector).forEach((element) => this.initNest(element)); // Type assertion added
    }
    // Update components within a specific element
    update(scope = document) {
        const selector = `[${this.options.componentAttr}]`;
        scope.querySelectorAll(selector).forEach((element) => {
            const mounted = this.mountedRoots.get(element);
            const componentName = mounted ? mounted.componentName : null;
            const registered = componentName ? this.registry.getComponent(componentName) : null;
            if (registered) {
                const newProps = this.parseProps(element);
                const renderMethod = registered.async ? this.renderer.renderAsync : this.renderer.render;
                renderMethod.call(this.renderer, element, registered, newProps); // Cast to HTMLElement
                this.mountedRoots.updateProps(element, newProps); // Update stored props
            }
            else {
                if (mounted) {
                    console.warn(`Component ${componentName} not registered.`);
                }
                else {
                    this.mountedRoots.warnIfNotMounted(element);
                    this.initNest(element);
                }
            }
        });
    }
}
exports.default = DomNest;
